export default "__VITE_ASSET__DUoRHQCU__"